import React from 'react';
import './uvp.scss';

const upvData = [
  { 
    'id':'1',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/collection.png',
    'value': `Chat before Hiring`
  },
  {
    'id':'2',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/247Support.png',
    'value': `Local Guides Available`
  },
  { 
    'id':'3',
    'imageSrc': 'https://honeyguide.s3.amazonaws.com/assets/icons/certificate.png',
    'value': `Certified and Well-trained`
  }
];


export default function UVP() {
  return (
    <ul className="uvp">
      {upvData.map(data => {
        return(
          <li key={data.id}>
            <div className="uvp-blog">
              <img src={data.imageSrc} alt={data.value}/>
            <p>{data.value}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
